import { createApp, h } from 'vue';
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import DialogService from 'primevue/dialogservice';
import ToastService from 'primevue/toastservice';
import Tooltip from 'primevue/tooltip';
import Dialog from 'primevue/dialog';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import Badge from 'primevue/badge';
import Divider from 'primevue/divider';
import Dropdown from 'primevue/dropdown';
import { createInertiaApp } from '@inertiajs/vue3';
import { Switch } from '@headlessui/vue';
import Datepicker from 'vue3-datepicker';
import draggable from 'vuedraggable';
import SwapIcon from '@apparatix/icons/SwapIcon.vue';
/*
 * Documentation: https://github.com/kouts/vue-search-input
 */
import SearchInput from 'vue-search-input';
import 'vue-search-input/dist/styles.css';
// import 'primevue/resources/themes/lara-light-indigo/theme.css';
import 'primevue/resources/themes/aura-light-blue/theme.css';
import 'primeicons/primeicons.css';
import { bootstrap } from './bootstrap';
// import '../../public/res/dhx/3.6/dhtmlx.js';
// import { initSentry } from './Sentry';
bootstrap();
// initSentry();
const app = createApp({});
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';
app.component('Datepicker', Datepicker);
app.component('Draggable', draggable);
app.component('SearchInput', SearchInput);
// eslint-disable-next-line vue/no-reserved-component-names
app.component('Switch', Switch);
// eslint-disable-next-line vue/no-reserved-component-names
app.component('Dialog', Dialog);
app.component('InputText', InputText);
app.component('PvTextarea', Textarea);
app.component('PvBadge', Badge);
app.component('PvDivider', Divider);
app.component('PvDropdown', Dropdown);
app.component('PvToast', Toast);
app.component('SwapIcon', SwapIcon);
app.use(PrimeVue, { ripple: false })
    .use(ConfirmationService)
    .use(DialogService)
    .use(ToastService);
app.directive('tooltip', Tooltip);
app.config.globalProperties.$moment = require('moment');
app.config.globalProperties.$dateFns = require('date-fns');
app.config.globalProperties.$lodash = require('lodash');
autoloadComponents(app);
createInertiaApp({
    title: () => `${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(PrimeVue, { ripple: false })
            .use(DialogService)
            .use(ToastService)
            .use(ConfirmationService)
            // @ts-expect-error route looks undefined, not sure if it's being populated automagically by inertia. Just ignoring error for now
            // eslint-disable-next-line no-undef
            .mixin({ methods: { route } })
            .mount(el);
    },
    progress: { color: '#4B5563' },
});
// TODO: either split this into two files, or figure out some way to tell if we're in an inertia context
// On Inertia pages this attempts to mount an already mounted app which causes a (non-fatal) error
app.mount('#app');
// Autoload all components in ./Components - based off https://jellehak.medium.com/autoloading-of-components-with-vue-ef190197b49d
// Treeshaking will remove unused components from production files
function autoloadComponents(a) {
    // https://webpack.js.org/guides/dependency-management/#require-context
    const requireComponent = require.context('./Components/', // directory to look in
    true, // include subdirectories
    /\.vue$/);
    requireComponent.keys().forEach(fileName => {
        const componentConfig = requireComponent(fileName);
        const componentName = fileName
            .replace(/^.*[\\/]/, '') // Remove path
            .replace(/\.\w+$/, ''); // Remove extension
        a.component(componentName, componentConfig.default || componentConfig);
    });
}
